import React from 'react'
import images from '../../../../app/utlis/image'

const HosFeatureBox = () => {
    return (
        <div>
            <div className='border-t-8 border-darkGreyTernary mx-4 md:mx-12'></div>
            <div className='flex flex-col md:flex-row'>
                <div className='bg-yellow w-full md:w-auto'>
                    <img src={images.HOSPITALFEATURE} className='w-full h-auto' alt="Hospital feature" />
                </div>
                <div className={`bg-yellow text-start p-6 md:p-12 md:pl-0 md:pr-12 lg:pr-48 w-full text-black flex flex-col justify-center`}>
                    <div className='text-2xl md:text-3xl lg:text-4xl font-bold mb-2 md:mb-4'>Main features of our hospital
                        intranet systems</div>
                    <div className='text-base md:text-lg lg:text-xl leading-6 md:leading-8'>Our specialized hospital intranet systems are built to improve internal
                        communication, collaboration, & resource management. Key features are:</div>
                </div>
            </div>
            <div className='border-b-8 border-darkGreyTernary mx-4 md:mx-12'></div>
        </div>
    )
}

export default HosFeatureBox
